interface QuestionOption {
    [key: string]: string[] | string[][];
}

interface QuestionData {
    choose: string;
    baseNote: string[];
    answer: string | string[] | string[][];
    options: QuestionOption;
}

export const getOptionsFromData = (data: QuestionData, questionType: string) => {
    if (!Array.isArray(data.options)) {
        return data.options;
    }

    const options: QuestionOption = {};
    let optionIndex = 0;

    const { choose, baseNote, answer } = data;

    const buildOption = (letter: string): string[] | string[][] => {
        if (choose === letter) {
            if (questionType === 'SelectionYinCheng') {
                return [...baseNote, answer as string]
            }

            if (questionType === 'SelectionHeXian') {
                return [...baseNote, ...(answer as string[])]
            }

            if (questionType === 'SelectionYinJie') {
                return [baseNote, ...(answer as string[][])]
            }
        }

        if (!Array.isArray(data.options) || optionIndex >= data.options.length) {
            throw new Error('Invalid options array or index');
        }

        const option = data.options[optionIndex];
        optionIndex++;
        return questionType === 'SelectionYinJie'
            ? [baseNote, ...option]
            : baseNote.concat(option);
    };

    ['A', 'B', 'C', 'D'].forEach((letter: string) => {
        options[letter] = buildOption(letter);
    });

    return options;
};

export function formatYinJieOption(options: any[]): string[][] {
    // Case 1: First element is string, rest are 1D arrays
    if (typeof options[0] === 'string' &&
        options.slice(1).every(item => Array.isArray(item) && !Array.isArray(item[0]))) {
        return options.map(opt => Array.isArray(opt) ? opt : [opt]);
    }

    // Case 2: First element is string, rest is a 2D array
    if (typeof options[0] === 'string' &&
        Array.isArray(options[1]) && Array.isArray(options[1][0])) {
        return [[options[0]], ...options[1]];
    }

    // Case 3: Already in correct format
    return options;
}

function isStringArray(data: any): data is string[] {
    return Array.isArray(data) && data.every(item => typeof item === 'string');
}

export function formatHeXianOption(data: string[] | string[][]): string[] {
    // If already 1D array of strings, return as-is
    if (isStringArray(data)) {
        return data;
    }

    // Handle mixed array with strings and nested arrays
    if (Array.isArray(data) && 
        data.some(item => typeof item === 'string') && 
        data.some(item => Array.isArray(item))) {
        return data.flatMap(item => Array.isArray(item) ? item : [item]);
    }

    // Flatten 2D array
    return (data as string[][]).flat();
}
